import application from 'application/application';

application

	.value('templates', {
		'-1': {
			name: 'Inbox',
			class: 'inbox',
			logo: 'logo-inbox.svg'
		},
		'-2': {
			name: 'Start',
			class: 'start',
			logo: 'logo-start.svg'
		}
	});
